import {useContext} from "react";
import {CustomerContext} from "../components/CustomerContextProvider";

export default function useCustomerContext () {
    return useContext(CustomerContext);
}